
export interface INote {
    id: string;
    createUserId: string;
    name: string;
    content: string;
    order: number;
}

export class Note implements INote {
    id: string;
    createUserId: string;
    name: string;
    content: string;
    order: number;

    constructor(note: INote) {
        this.id = note.id;
        this.createUserId = note.createUserId;
        this.name = note.name;
        this.content = note.content;
        this.order = note.order;
    }
    
}